import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Config} from '../config/param';
import {MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-database',
  templateUrl: './database.component.html',
  styleUrls: ['./database.component.scss']
})
export class DatabaseComponent implements OnInit {

  public file: File = null;
  public progress = false;
  public message = '';
  public uploadStatus = false;

  constructor(
    private http: HttpClient,
    private dialogRef: MatDialogRef<any>
  ) {
  }

  ngOnInit() {
  }

  changeFile(event) {
    this.file = event.target.files[0];
  }

  upload() {
    this.progress = true;
    const fd = new FormData();
    fd.append('file', this.file, 'database.zip');
    this.http.post(`${Config.API_URL}/upload/uploadfiles`, fd)
      .subscribe((res: any) => {
        if (res.status === 'success') {
          this.message = `<div class="text-success">Votre base de données est mis à jour.</div>
        <strong class="text-success">Il faut redémarrer l'application pour prendre en compte les modifications.</strong>`;
          this.progress = false;
          this.uploadStatus = true;
          setTimeout(() => {
            this.reboot();
          }, 3000);
        } else {
          this.message = '<div class="text-danger">Erreur inconnue, merci de reimporter le fichier</div>';
          this.progress = false;
          this.uploadStatus = false;
        }
      });
  }

  selectFile() {
    $('#database').trigger('click');
  }

  reboot() {
    this.http.post(`${Config.API_URL}/reboot`, {})
  }

  close() {
    this.dialogRef.close();
  }
}
